var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteSbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650391,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6576_31348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 13.6504V13.0504C21 12.2103 21 11.7903 20.8365 11.4694C20.6927 11.1872 20.4632 10.9577 20.181 10.8139C19.8601 10.6504 19.4401 10.6504 18.6 10.6504H17.4C16.5599 10.6504 16.1399 10.6504 15.819 10.8139C15.5368 10.9577 15.3073 11.1872 15.1635 11.4694C15 11.7903 15 12.2103 15 13.0504V13.6504M16.5 17.7754V21.5254M19.5 17.7754V21.5254M11.25 13.6504H24.75M23.25 13.6504V22.0504C23.25 23.3105 23.25 23.9406 23.0048 24.4219C22.789 24.8452 22.4448 25.1894 22.0215 25.4052C21.5402 25.6504 20.9101 25.6504 19.65 25.6504H16.35C15.0899 25.6504 14.4598 25.6504 13.9785 25.4052C13.5552 25.1894 13.211 24.8452 12.9952 24.4219C12.75 23.9406 12.75 23.3105 12.75 22.0504V13.6504",
    stroke: "#4D5761",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650391,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#D2D6DB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6576_31348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9.15039)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSbIcon);
export default __webpack_public_path__ + "static/media/DeleteSBIcon.59f264edd40b3930abadc2ec9b3a5393.svg";
export { ForwardRef as ReactComponent };